/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:11:05
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-18 15:24:17
 */
import req from "@/utils/request";

export const organTree = (params) => req.post("/manager-service/m/organization/organTree", params);
export const roleList = (params) => req.post("/manager-service/m/role/list", params);
export const create = (params) => req.post("/manager-service/m/management/create", params);
export const siteList = (params) => req.post("/site-service/m/site/list", params);
export const list = (params) => req.post("/manager-service/m/management/list", params);
export const update = (params) => req.post("/manager-service/m/management/update", params);
export const deleteOne = (params) => req.post("/manager-service/m/management/delete", params);